@if (submitted()) {
  <section class="review-nudge" aria-live="polite">
    <mat-icon>{{ isPrivateFeedback() ? 'support_agent' : 'favorite' }}</mat-icon>
    @if (isPrivateFeedback()) {
      <h2>Thank you — this stays with the kitchen</h2>
      <p>We will not publish a rating under 4. The team will use your note to fix what went wrong.</p>
    } @else {
      <h2>Thank you</h2>
      <p>Your review is with our team and may appear on the site once it is published.</p>
    }
  </section>
} @else if (visible()) {
  <section class="review-nudge">
    <p class="eyebrow">After your meal</p>
    <h2>{{ headline() }}</h2>
    <p class="lede">
      @if (isPrivateFeedback()) {
        Tell us privately what missed the mark. Ratings under 4 stay with Unaavu — they are not posted on the homepage.
      } @else {
        A short note helps the next guest. We only publish 4 and 5 star reviews after a quick check.
      }
    </p>
    <div class="rating-picker" role="radiogroup" aria-label="Rating">
      @for (star of [1, 2, 3, 4, 5]; track star) {
        <button
          type="button"
          class="star-btn"
          [class.filled]="star <= rating()"
          (click)="setRating(star)"
          [attr.aria-label]="star + ' stars'">
          ★
        </button>
      }
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Your name</mat-label>
      <input matInput [value]="guestName()" (input)="onNameInput($event)" maxlength="80" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ isPrivateFeedback() ? 'What should we fix?' : 'How was your visit?' }}</mat-label>
      <textarea matInput rows="3" [value]="comment()" (input)="onCommentInput($event)" maxlength="1000"></textarea>
    </mat-form-field>
    @if (error()) {
      <p class="form-error" role="alert">{{ error() }}</p>
    }
    <div class="actions">
      <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="submitting()">
        {{ submitting() ? 'Sending…' : isPrivateFeedback() ? 'Send private note' : 'Share review' }}
      </button>
      <button mat-button type="button" (click)="dismiss()">Not now</button>
    </div>
  </section>
}
